import type { Address } from '@/utils/types/renter.interface';

export const mapAddressToPayload = (address: Address) => ({
  monolith_building_ids: [address.monolith_building_id],
  ...((address.property_alpha_id || address.property_id) && {
    property_id: address.property_alpha_id || address.property_id,
  }),
  ...(address.address_id && { address_id: address.address_id }),
  ...(address.line1 && { line1: address.line1 }),
  ...(address.city && { city: address.city }),
  ...(address.state && { state: address.state }),
  ...(address.postal_code && { postal_code: address.postal_code }),
});
